import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const getContents = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/bodyAndMind/contents`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveContentWithImage = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/contents/image`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveContentWithVideo = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/contents/video`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateContentWithImage = async (uuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/contents/images/${uuid}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response;
};

export const updateContentWithVideo = async (uuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/contents/video/${uuid}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;

};

export const searchContent = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/contents`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;

};

export const deleteContent = async (uuid) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/bodyAndMind/contents/${uuid}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

/**
 * @returns {Promise<{ recentFromMeApp: boolean, customName: string | null }>}
 */
export const getCompanyBodyAndMindSettings = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/bodyAndMind/settings`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateRecentFromMeApp = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/contents`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

/**
 * @param {string|null} customName
 * @returns {Promise<{ customName: string | null }>}
 */
export const updateCustomBodyAndMindName = async (customName) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const payload = { name: customName };
    const response = await axios.put(`${API_URL}/company/bodyAndMind/customName`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const saveAttachments = async (postUuid, attachments) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/contents/attachments`, 
        { postUuid, attachments }, 
        { headers: { Authorization: "Bearer " + token } }
    );
    return response.data;
};